import "./style.css";
import { t } from "../../services/formatters";
import { TextInput } from "../TextInput";
import { useSession } from "../../hooks/useSession";
import { isName, isEmail, isPhone, isCap, isCf } from "../../services/validators";
import { useState } from "react";

export const FormDatiUtenteClinkDirect = ({ nomeAgente = "" }) => {
    const { read, update } = useSession();

    const [nameState, setNameState] = useState(isName(read("nome")) ? 3 : 1);
    const [surnameState, setSurnameState] = useState(isName(read("cognome")) ? 3 : 1);
    const [emailState, setEmailState] = useState(isEmail(read("email")) ? 3 : 1);
    const [phoneState, setPhoneState] = useState(isPhone(read("cellulare")) ? 3 : 1);
    const [capState, setCapState] = useState(isCap(read("cap_utente")) ? 3 : 1);
    const [codiceFiscaleState, setCodiceFiscaleState] = useState(isCf(read("codiceFiscale")) ? 3 : 1);
    // const [noteState, setNoteState] = useState(3);

    const verificaNomeCognomeNelCF = () => {
        const nome = read("nome");
        const cognome = read("cognome");
        const codiceFiscale = read("codiceFiscale");

        if (!codiceFiscale || codiceFiscale.length !== 16) return false;

        const normalize = (str) =>
            str
                .toUpperCase()
                .replace(/[^A-Z]/g, "") // rimuove accenti, spazi ecc.
                .replace(/[ÀÁÂÃÄÅ]/g, "A")
                .replace(/[ÈÉÊË]/g, "E")
                .replace(/[ÌÍÎÏ]/g, "I")
                .replace(/[ÒÓÔÕÖ]/g, "O")
                .replace(/[ÙÚÛÜ]/g, "U");

        const estraiConsonanti = (s) => normalize(s).replace(/[AEIOU]/g, "");
        const estraiVocali = (s) => normalize(s).replace(/[^AEIOU]/g, "");

        // Codice cognome: 3 lettere
        const codCognome = (() => {
            const cons = estraiConsonanti(cognome);
            const voc = estraiVocali(cognome);
            const str = (cons + voc + "XXX").substring(0, 3);
            return str;
        })();

        // Codice nome: 3 lettere con regole particolari
        const codNome = (() => {
            const cons = estraiConsonanti(nome);
            let str = "";
            if (cons.length >= 4) {
                // prende la 1°, 3° e 4° consonante
                str = cons[0] + cons[2] + cons[3];
            } else {
                const voc = estraiVocali(nome);
                str = (cons + voc + "XXX").substring(0, 3);
            }
            return str;
        })();

        const cfCognome = codiceFiscale.substring(0, 3);
        const cfNome = codiceFiscale.substring(3, 6);

        return codCognome.toLowerCase() === cfCognome.toLowerCase() && codNome.toLowerCase() === cfNome.toLowerCase();
    };

    const updateCfStateBasedOnName = () => {
        if (isCf(read("codiceFiscale"))) {
            if (verificaNomeCognomeNelCF()) {
                setCodiceFiscaleState(3);
                update("cfErrorInForm", false);
            } else {
                setCodiceFiscaleState(4);
                update("cfErrorInForm", true);
            }
        } else {
            setCodiceFiscaleState(4);
            update("cfErrorInForm", true);
        }
    };

    return (
        <div className={`section white-box input-box-component full-form`}>
            <div className="text-center">
                <h2 className="color-text-primary">Inserisci i tuoi dati</h2>
                <br />
                <p>
                    Verrai contattato dal nostro consulente <b>{nomeAgente}</b> per decidere luogo e orario.
                </p>
            </div>

            <p className="crea-appto-error full-form-appto-error hidden">Tutti i campi vanno compilati correttamente.</p>
            <br />

            <TextInput
                state={nameState}
                name="nome"
                placeholder={t("name")}
                value={read("nome")}
                onChange={(value) => {
                    setNameState(1);
                    update("nome", value);
                }}
                onBlur={(value) => {
                    isName(value) ? setNameState(3) : setNameState(4);
                    updateCfStateBasedOnName();
                }}></TextInput>
            <TextInput
                state={surnameState}
                name="cognome"
                placeholder={t("surname")}
                value={read("cognome")}
                onChange={(value) => {
                    setSurnameState(1);
                    update("cognome", value);
                }}
                onBlur={(value) => {
                    isName(value) ? setSurnameState(3) : setSurnameState(4);
                    updateCfStateBasedOnName();
                }}></TextInput>
            <TextInput
                state={emailState}
                type="email"
                name="email"
                placeholder={t("email")}
                value={read("email")}
                onChange={(value) => {
                    setEmailState(1);
                    update("email", value);
                }}
                onBlur={(value) => {
                    isEmail(value) ? setEmailState(3) : setEmailState(4);
                }}></TextInput>
            <TextInput
                state={phoneState}
                name="cellulare"
                placeholder={t("tel")}
                value={read("cellulare")}
                onChange={(value) => {
                    setPhoneState(1);
                    update("cellulare", value);
                }}
                onBlur={(value) => {
                    isPhone(value) ? setPhoneState(3) : setPhoneState(4);
                }}></TextInput>

            <TextInput
                state={capState}
                name="cap"
                placeholder={t("cap")}
                value={read("cap")}
                onChange={(value) => {
                    setCapState(1);
                    update("cap", value);
                }}
                onBlur={(value) => {
                    isCap(value) ? setCapState(3) : setCapState(4);
                }}
                maxLength={5}></TextInput>

            <TextInput
                state={codiceFiscaleState}
                name="codiceFiscale"
                placeholder={`${t("inserisci_cf")}*`}
                value={read("codiceFiscale")}
                onChange={(value) => {
                    setCodiceFiscaleState(1);
                    update("codiceFiscale", value);
                    update("codiceFiscale_external", value);
                }}
                onBlur={(value) => {
                    updateCfStateBasedOnName();
                }}
                maxLength={16}></TextInput>

            {/* <TextInput
        state={0}
        name="note"
        placeholder={t("note")}
        value={read("note")}
        onChange={(value) => {
          update("note", value);
        }}></TextInput> */}
        </div>
    );
};
